export default "__VITE_ASSET__3nlawPjS__"